module.exports = __webpack_public_path__ + "static/img/200196.26c6c5a7.png";